module.exports = __webpack_public_path__ + "static/img/260_TO8_2339_og.a1203e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/260_TO8_2339_og.jpg
// module id = vlxe
// module chunks = 0